import { donorRecipientConstants, apiConstants } from '../constants';
import url from '../../helpers/url';

export const saveDonorRecipient = ({ donorId, recipientId, donorRecipientLinkId, form }) => ({
    type: apiConstants.API,
    payload: {
        url: donorRecipientLinkId ?
            url.donorRecipientLinkByID.replace(':donorId', donorId).replace(':recipientId', recipientId).replace(':donorRecipientLinkId', donorRecipientLinkId) :
            url.donorRecipientLinks.replace(':donorId', donorId).replace(':recipientId', recipientId),
        method: 'POST',
        body: form,
        request: () => ({ type: donorRecipientConstants.SAVING_DONOR_RECIPIENT_REQUEST }),
        success: (data) => ({ type: donorRecipientConstants.SAVING_DONOR_RECIPIENT_SUCCESS, data }),
        failure: (error) => ({ type: donorRecipientConstants.SAVING_DONOR_RECIPIENT_FAILURE, error }),
        formatData: (data) => ({ form: { ...data[0] }}),
        progress: {
            success: { message: () => 'Saved donor recipient link.' }
        }
    }
});

export const deleteDonorRecipient = ({ donorId, recipientId, donorRecipientLinkId }) => ({
    type: apiConstants.API,
    payload: {
        url: url.donorRecipientLinkByID.replace(':donorId', donorId).replace(':recipientId', recipientId).replace(':donorRecipientLinkId', donorRecipientLinkId),
        method: 'DELETE',
        request: () => ({ type: donorRecipientConstants.DELETE_DONOR_RECIPIENT_REQUEST }),
        success: (data) => ({ type: donorRecipientConstants.DELETE_DONOR_RECIPIENT_SUCCESS, data }),
        failure: (error) => ({ type: donorRecipientConstants.DELETE_DONOR_RECIPIENT_FAILURE, error }),
        formatData: () => donorRecipientLinkId,
        progress: {
            request: { message: () => 'Deleting donor recipient link.' },
            success: { message: () => 'Deleted donor recipient link.' }
        }
    }
});

export const loadDonorRecipients = (donorId) => ({
    type: apiConstants.API,
    payload: {
        url: url.donorRecipientsLinks.replace(':donorId', donorId),
        method: 'GET',
        request: () => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENTS_REQUEST }),
        success: (data) => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENTS_SUCCESS, data }),
        failure: (error) => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENTS_FAILURE, error })
    }
});

export const loadDonorRecipientLinkProgresses = (donorId, recipientId, donorRecipientLinkId) => ({
    type: apiConstants.API,
    payload: {
        url: url.donorRecipientLinkProgresses.replace(':donorId', donorId).replace(':recipientId').replace(':donorRecipientLinkId', donorRecipientLinkId),
        method: 'GET',
        request: () => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_REQUEST }),
        success: (data) => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_SUCCESS, data }),
        failure: (error) => ({ type: donorRecipientConstants.LOAD_DONOR_RECIPIENT_PROGRESSES_FAILURE, error })
    }
});



// WEBPACK FOOTER //
// ./src/redux/actions/donorRecipient.actions.js